import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { BRAND_PAGES } from '../data/brandPages';

const BrandsIndexPage = () => {
  useEffect(() => {
    document.title = "All Brands — Kids Size Finder";
    const setMeta = (name, content, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };
    setMeta('description', "Find your child's exact size across 36+ brands. Free size finder tools for H&M, Zara, Nike, Carter's, Old Navy, and more.");
    setMeta('og:title', 'All Brands — Kids Size Finder', true);
    setMeta('og:description', "Find your child's exact size across 36+ brands.", true);
  }, []);

  return (
    <div className="doc-page">
      <nav className="doc-nav" data-testid="brands-index-nav">
        <Link className="nav-logo" to="/" data-testid="nav-logo">
          <img src="/ruler-icon.png" alt="" className="nav-logo-icon-img-sm" />
          <span className="nav-logo-text-sm">Kids Size Finder</span>
        </Link>
        <Link className="nav-back" to="/" data-testid="nav-back-link">← Back to home</Link>
      </nav>

      <main className="doc-main" data-testid="brands-index-content">
        <div className="doc-header">
          <div className="doc-title">All Brands</div>
          <div className="doc-meta">36 brands with free size finders</div>
        </div>

        <p style={{ fontSize: '15px', color: '#555', lineHeight: 1.7, marginBottom: '32px' }}>
          Enter your child's measurements and get the exact size for any brand below — plus how long it will fit. Every size finder is free, no account needed.
        </p>

        <div className="brands-index-grid">
          {BRAND_PAGES.map((brand) => (
            <Link
              key={brand.slug}
              to={`/brands/${brand.slug}`}
              className="brands-index-card"
              data-testid={`brand-link-${brand.slug}`}
            >
              <span className="brands-index-name">{brand.display}</span>
              <span className="brands-index-arrow">→</span>
            </Link>
          ))}
        </div>
      </main>

      <footer className="doc-footer" data-testid="brands-index-footer">
        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="mailto:support@kidssizefinder.com">Support</a>
        </div>
        <p className="footer-copy">© 2026 Outgrow Solutions Oy. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default BrandsIndexPage;
